import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'procure-environment-banner',
  templateUrl: './environment-banner.component.html',
  styleUrl: './environment-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnvironmentBanner {
  readonly identifier = input<string>();
}
